import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import StandardSelect from 'app/components/common/standard-select';
import IntsDuck       from 'app/ducks/company-admin/integrations';

class NylasCalendarPicker extends React.PureComponent {

  constructor(props) {
    super(props);

    this.onChangeCal = this.onChangeCal.bind(this);
  }

  componentDidMount() {
    this.props.loadCals().then(() => {
      this.applyDefault();
    });
  }

  applyDefault() {
    if (this.props.value) return;
    if (!this.props.defaultWhenNull) return;
    if (this.props.defaultCal) {
      this.props.onChange(this.props.defaultCal.id);
    }
  }

  get debug() {
    return {
      allCalsLength: this.props.allCals?.length,
      validCalsLength: this.props.validCals?.length,
      defaultCal: this.props.defaultCal,
      currentCal: this.currentCal,
    };
  }

  get currentCal() {
    return (this.props.allCals || []).find(cal => cal.id === this.props.value) || null;
  }

  get selectOpts() {
    const {currentCal} = this;
    let foundCurrent = false;
    const opts = (this.props.validCals || []).map((cal) => {
      if (cal.id === currentCal?.id) foundCurrent = true;
      return {label: cal.title, value: cal.id};
    });
    if (!foundCurrent && currentCal) {
      opts.push({label: currentCal.title, value: currentCal.id});
    }
    return opts;
  }

  onChangeCal(calId) {
    this.props.onChange(calId || null);
  }

  render() {
    return (
      <StandardSelect value={this.props.value} options={this.selectOpts} onSelect={this.onChangeCal} allowClear label="Select a calendar" />
    );
  }

}

NylasCalendarPicker.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  defaultWhenNull: PropTypes.bool,
};

NylasCalendarPicker.defaultProps = {
  value: null,
  defaultWhenNull: false,
};

const stateToProps = (state) => ({
  defaultCal: IntsDuck.Slx.defaultCalendar(state),
  validCals: IntsDuck.Slx.validCalendars(state),
  allCals: IntsDuck.Slx.allCalendars(state),
});

const dispatchToProps = (dispatch) => ({
  loadCals: () => dispatch(IntsDuck.Ax.loadCalendars()),
});

export default connect(stateToProps, dispatchToProps)(NylasCalendarPicker);
